module.exports = __webpack_public_path__ + "static/img/sh4.d671ef3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sh4.svg
// module id = ldaC
// module chunks = 1